import {
  Checkbox,
  Col,
  Divider,
  Form,
  FormInstance,
  Radio,
  Row,
  Typography,
} from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';

import QuotationReportMoreOptions from './QuotationReportMoreOptions';
import {
  QuestQuotationReportFormValues,
  QuotationReportType,
  QuotationSituationFilter,
} from '@/core/domain/questReport/Reports/Quotation/Quotation.types';
import { CheckboxGroupButtons } from '@/components/_common';

interface Props {
  form: FormInstance<QuestQuotationReportFormValues>;
}

const PurchasesQuotationReportForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;

  const situationOptions = [
    {
      label: 'Configurando',
      value: QuotationSituationFilter.configuring,
    },
    {
      label: 'Aguardando Ofertas',
      value: QuotationSituationFilter.awaitingOffers,
    },
    {
      label: 'Respondido',
      value: QuotationSituationFilter.answered,
    },
    {
      label: 'Vencedores Selecionados',
      value: QuotationSituationFilter.winnersSelected,
    },
    {
      label: 'Encerrado',
      value: QuotationSituationFilter.done,
    },
  ];

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields form={form} />

      <Row gutter={[16, 8]}>
        <Col sm={24}>
          <Title level={5}>
            {intl.formatMessage({
              id: 'quotation.form.reportType',
            })}
          </Title>

          <Form.Item
            name="reportType"
            initialValue={QuotationReportType.itemPerSuppliers}
          >
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio value={QuotationReportType.itemPerSuppliers}>
                {intl.formatMessage({
                  id: 'quotation.form.reportType.itemsSuppliers',
                })}
              </Radio>
              <Radio value={QuotationReportType.supplierPerItems}>
                {intl.formatMessage({
                  id: 'quotation.form.reportType.suppliersItems',
                })}
              </Radio>
              <Radio value={QuotationReportType.vehiclePerQuotation}>
                {intl.formatMessage({
                  id: 'quotation.form.reportType.vehicleQuotation',
                })}
              </Radio>
              <Radio value={QuotationReportType.workOrderPerQuotation}>
                {intl.formatMessage({
                  id: 'quotation.form.reportType.OSQuotation',
                })}
              </Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const reportType = getFieldValue('reportType');

              return (
                <>
                  {(reportType === QuotationReportType.itemPerSuppliers ||
                    reportType === QuotationReportType.supplierPerItems) && (
                    <Form.Item
                      initialValue={false}
                      valuePropName="checked"
                      name="orderBySmallerPrice"
                    >
                      <Checkbox>Menor Preço</Checkbox>
                    </Form.Item>
                  )}
                </>
              );
            }}
          </Form.Item>
        </Col>

        <Col>
          <Title level={5}>Selecione as Situações Desejadas</Title>

          <Form.Item
            name="SituationFilter"
            initialValue={[QuotationSituationFilter.configuring]}
            noStyle
          >
            <CheckboxGroupButtons options={situationOptions} />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Divider />

          <QuotationReportMoreOptions form={form} />
        </Col>
      </Row>
    </Form>
  );
};

export default PurchasesQuotationReportForm;
